var $ = require('jquery');
var Configuration = EY.Consultation.Lookups.Configuration;
var Consultation = require('Consultation');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');

var tooltip = function (selector) {
    selector.attr({
        'data-tooltip-title': selector.text(),
        'data-placement': 'top'
    });
};

// Expects the owning view to have an HTML element with this class: tool-tip. 
// The text/html from .tool-tip element is used to populate data attribute: 'data-original-title'.
//module.exports.Tooltip = Marionette.Behavior.extend({
//    onRender: function () {
//        tooltip(this.$('.tool-tip'));
//        $('[data-toggle="tooltip"]').tooltip({
//            trigger: 'hover'
//        }); 
//    }
//});
module.exports.tooltip = function (selector) {
    selector.find("div.tooltip-div").remove();
    if (selector.attr("data-tooltip-title"))
        selector.append(" <div class='tooltip-div hidden-print'><span class='tooltip-text-css'>" + selector.attr("data-tooltip-title") + "</span></div>");
};

module.exports.Tooltip = Marionette.Behavior.extend({
    onRender: function () {
        this.$el.find(".tooltip-css").append(" <div class='hidden-print'><span class='tooltip-text-css'>" + this.$el.find(".tooltip-css").attr("data-tooltip-title") + "</span></div>");
    }
});

// Expects the owning view to be simple Marrionette view that needs to render a backgrid string column with tooltip.
module.exports.TooltipGrid = Marionette.Behavior.extend({
    onRender: function () {
        this.change();
    },
    modelEvents: {
        change: 'change'
    },
    change: function () {
        var name = this.view.options.column.get('name');
        var value = this.view.model.get(name);

        tooltip(this.$el.addClass(name).attr('data-container', 'body').html(value));
        module.exports.tooltip(this.$el.addClass(name).html(value));
    }
});

module.exports.PrintCheckbox = Marionette.Behavior.extend({
    onDomRefresh: function () {
        var checkedCheckBoxes = this.$el.find('input.print-checkbox[type=checkbox]:checked');
        var unCheckedCheckBoxes = this.$el.find('input.print-checkbox[type=checkbox]:not(:checked)');
        checkedCheckBoxes.addClass('hidden-print');
        unCheckedCheckBoxes.addClass('hidden-print');
        $('<i class="fa fa fa-square-o visible-print-inline-block" aria-hidden="true"></i>').insertAfter(unCheckedCheckBoxes);
        $('<i class="fa fa-check-square-o visible-print-inline-block" aria-hidden="true"></i>').insertAfter(checkedCheckBoxes);
    }
});

module.exports.MobileView = Marionette.Behavior.extend({
    onDomRefresh: function () {
        if (EY.Consultation.Lookups.IsHandHeldDevice) {
            this.$el.find('[data-hide-small-screen="true"]').hide();
        }
    }
});

//This behavior is attached to UI elements like buttons/anchors etc.
//The main aim of this behavior is to prevent clicking the UI element multiple
//times quickly to trigger the functionality again and again.
//USAGE:
//1. Attach the behavior to the view in which the buttons/links are present.
//2. Add the prevent-multi-click class to the button/link
module.exports.DisableMultipleClicks = Marionette.Behavior.extend({
    ui: {
        preventMultiClick: '.prevent-multi-click'
    },
    events: {
        'click @ui.preventMultiClick': 'handleClick'
    },
    handleClick(e) {
        var elem = e.target;
        if (!elem) return;
        $(elem).addClass('disabled');
        setTimeout(function () { $(elem).removeClass('disabled'); }, EY.Consultation.Lookups.Configuration.MultiClickDelay);
    }
});

///ActionStatus Interface
//initMessage: Message to show when action button is clicked
//successMessage: Message to show when action is completed successfully
//duration: Duration for which success message stays visible
//successEvents: Event that signals success
//failEvent: Event that signals failure
module.exports.ActionStatus = Marionette.Behavior.extend({
    ui: {
        actionStatus: '.action-status'
    },
    events: {
        'click @ui.actionStatus': 'handleClick'
    },
    handleClick(e) {

        if (!Configuration.EnableSaveMessage) return;

        //1. Show in progress message when button is clicked.
        //2. If something happens - remove in progress message.
        //3. If successful - change message to success and hide after x seconds.

        var options = this.options;
        
        var initMessage = !!options.initMessage ? options.initMessage : e.currentTarget.innerText + Labels.InProgress;
        var successMessage = !!options.successMessage ? options.successMessage : Labels.ActionCompleted;
        var duration = options.duration || Configuration.EnableSaveMessageDuration;

        //Show toast on button click
        Consultation.showActionToast({
            result: "success",
            text: initMessage
        });

        options.model.once(options.successEvents, function() {
            //Set the successMessage
            Consultation.showActionToast({
                result: "success",
                text: successMessage
            });
            
            setTimeout(function () {
                Consultation.hideActionToast();
            }, duration);
        });

        !!options.failEvent && options.model.once(options.failEvent, function() {
            
            Consultation.hideActionToast();
        });
    }
});


// WEBPACK FOOTER //
// ./js/Modules/UI/Behaviors.js